/**
 * Core constants and types for the portfolio application.
 * Following the design philosophy of 'Physicality with Digital Precision'.
 * Updated for 2026 standards.
 */

export const ROUTE_PATHS = {
  HOME: '/',
} as const;

export interface Experience {
  id: string;
  company: string;
  role: string;
  duration: string;
  location?: string;
  achievements: string[];
  logoUrl?: string;
}

export interface Skill {
  id: string;
  name: string;
  category: 'Frontend' | 'Backend' | 'Design' | 'Tools' | 'Soft Skills';
  proficiency: number; // 0 to 100
  iconName?: string;
}

export interface Project {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  tags: string[];
  liveUrl?: string;
  githubUrl?: string;
  isFeatured?: boolean;
}

export const NAV_ITEMS = [
  { label: 'About', href: '#about' },
  { label: 'Experience', href: '#experience' },
  { label: 'Skills', href: '#skills' },
  { label: 'Projects', href: '#projects' },
  { label: 'Contact', href: '#contact' },
] as const;

export const SKILL_CATEGORIES = [
  'Frontend',
  'Backend',
  'Design',
  'Tools',
  'Soft Skills',
] as const;

/**
 * Utility to scroll to a specific section by ID with an offset for the fixed header
 */
export function scrollToSection(id: string) {
  const element = document.getElementById(id.replace('#', ''));
  if (element) {
    const headerOffset = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
}

/**
 * Constants for social links
 */
export const SOCIAL_LINKS = {
  github: 'https://github.com/',
  linkedin: 'https://linkedin.com/in/',
  twitter: 'https://twitter.com/',
  email: 'mailto:contact@example.com',
} as const;